// extracted by mini-css-extract-plugin
export default {"Box":"base-project-view-filter-input-module__Box--kBl8F"};